import { createFileRoute } from '@tanstack/react-router';

import { crownQueryClient } from '@/common/api/crownQueryClient';
import { getTeamMemberUserQuery } from '@/features/administrator-panel/team/team-member-view/api/teamMemberApi';
import { fullName } from '@/lib/fullName';
import { TeamMemberView } from '@/features/administrator-panel/team/team-member-view/TeamMemberView.tsx';

export const Route = createFileRoute('/admin/configuration/team/$userId')({
  loader: ({ params }) =>
    crownQueryClient.ensureQueryData(getTeamMemberUserQuery(params.userId)),
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData ? fullName(loaderData.individual) : 'Team Member',
      },
    ],
  }),
  component: TeamMemberView,
});
